<template>
    <v-card class="pa-3">
        <v-card-title class="headline pl-0 pt-2"
            >{{ form && form.id ? "Update" : "Add" }} Regstration
            Form</v-card-title
        >

        <v-layout row>
            <div class="font-weight-medium width-150 mb-2">
                {{ student && student.id ? "Student Name:" : "Account Name:" }}
            </div>
            <div>{{ getName() }}</div>
        </v-layout>

        <v-layout row>
            <div class="font-weight-medium width-150 mb-2">Address:</div>
            <div>{{ getAddress() }}</div>
        </v-layout>

        <v-layout row v-if="form && form.enteredOn">
            <div class="font-weight-medium width-150 mb-2">Entered On:</div>
            <div>{{ form.enteredOn | time }}</div>
        </v-layout>

        <v-layout row v-if="form && form.enteredBy">
            <div class="font-weight-medium width-150 mb-2">Entered By:</div>
            <div>{{ form.enteredBy }}</div>
        </v-layout>

        <v-select
            v-model="votingRegForm.type"
            class=""
            label="Type"
            :items="['Husband', 'Wife', 'Daughter', 'Son']"
            ref="type"
            :rules="[rules.required]"
        >
        </v-select>

        <v-layout row>
            <v-text-field
                class="mb-0 mr-2"
                v-model="votingRegForm.firstName"
                label="First Name"
                ref="firstName"
                :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
                class="mb-0"
                v-model="votingRegForm.lastName"
                label="Last Name"
                ref="lastName"
                :rules="[rules.required]"
            ></v-text-field>
        </v-layout>

        <v-menu
            v-model="votingRegForm.datePickerMenu2"
            :close-on-content-click="false"
            offset-y
            full-width
            prepend-icon="mdi-currency-usd"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="votingRegForm.dob"
                    label="Date Of Birth - Format: YYYY/MM/DD"
                    prepend-icon="mdi-calendar"
                    v-on="on"
                ></v-text-field>
            </template>
            <v-date-picker v-model="votingRegForm.dob"></v-date-picker>
        </v-menu>

        <v-text-field
            class="mb-2"
            v-model="votingRegForm.note"
            label="Note"
            ref="note"
        ></v-text-field>

        <v-menu
            v-model="votingRegForm.datePickerMenu"
            :close-on-content-click="true"
            offset-y
            full-width
            prepend-icon="mdi-currency-usd"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="votingRegForm.dateSubmitted"
                    label="Date Submitted"
                    prepend-icon="mdi-calendar"
                    v-on="on"
                ></v-text-field>
            </template>
            <v-date-picker
                v-model="votingRegForm.dateSubmitted"
            ></v-date-picker>
        </v-menu>

        <v-select
            v-model="votingRegForm.status"
            class=""
            label="Status"
            :items="['Pending', 'Completed']"
            :rules="[rules.required]"
            ref="status"
        >
        </v-select>

        <v-card-actions class="mx-0 px-2 pb-2 mt-2">
            <v-spacer></v-spacer>
            <v-btn color="default" dark @click="close()">Cancel</v-btn>
            <v-btn
                color="warning"
                dark
                @click="deleteRegVorm"
                v-if="allowDeleting()"
                >Delete</v-btn
            >
            <v-btn :loading="processing" color="success" @click="save">
                Save
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import moment from "moment";
import { getDomain, sum, toISOLocal } from "../../utils/helpers.js";

export default {
    props: {
        form: Object,
        person: Object,
        student: Object,
        reload: Function,
        close: Function,
    },
    data() {
        return {
            processing: false,

            votingRegForm: {
                id: 0,
                firstName: "",
                lastName: "",
                dateSubmitted: "",
                type: "",
                note: "",
                status: "Pending",
                dob: "",
                datePickerMenu: false,
                datePickerMenu2: false,
            },

            rules: {
                required: (value) => !!value || "Required.",
            },
        };
    },
    async created() {},
    computed: {},
    watch: {
        form(newValue, oldValue) {
            if (newValue && newValue.id) {
                this.votingRegForm.id = newValue.id;
                this.votingRegForm.firstName = newValue.name
                    ? newValue.name.split(" ")[0]
                    : "";
                this.votingRegForm.lastName = newValue.name
                    ? newValue.name.split(" ")[1]
                    : "";
                this.votingRegForm.address = newValue.address;
                this.votingRegForm.type = newValue.type;
                this.votingRegForm.dob = newValue.dob
                    ? toISOLocal(new Date(newValue.dob)).substr(0, 10)
                    : "";
                this.votingRegForm.status = newValue.status;
                this.votingRegForm.note = newValue.note;
                this.votingRegForm.dateSubmitted = newValue.dateSubmitted
                    ? toISOLocal(new Date(newValue.dateSubmitted)).substr(0, 10)
                    : null;
            }
        },
        student(newValue, oldValue) {
            if (newValue && newValue.id) {
                this.votingRegForm.firstName = newValue.first;
                this.votingRegForm.lastName = newValue.last;
                this.votingRegForm.dob = toISOLocal(
                    new Date(newValue.dob),
                ).substr(0, 10);
            }
        },
        person(newValue, oldValue) {
            if (newValue && newValue.personID) {
                this.votingRegForm.lastName = newValue.lastEnglish;
            }
        },
    },
    methods: {
        getName() {
            if (this.student && this.student.id) {
                return this.student.first + " " + this.student.last;
            }

            if (this.person && this.person.personID) {
                return this.person.firstHebrew + " " + this.person.lastHebrew;
            }

            return;
        },
        getAddress() {
            if (this.student && this.student.id) {
                return (
                    this.student.address1 +
                    " " +
                    this.student.city +
                    " " +
                    this.student.zip
                );
            }

            if (this.person && this.person.personID) {
                return (
                    this.person.address1 +
                    " " +
                    this.person.city +
                    " " +
                    this.person.zip
                );
            }

            return;
        },
        allowDeleting() {
            return this.form && this.form.id;
        },
        async deleteRegVorm() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/votingRegstrationFormStatus/delete",
                    [this.form.id],
                );

                this.$notify({
                    text: "Registration Form Deleted",
                    group: "notification",
                    type: "success",
                });

                this.processing = false;
                this.close();
                this.reload();
            } catch (e) {
                this.processing = false;
            }
        },
        resetValidation() {
            if (this.$refs.name) {
                this.$refs.name.resetValidation();
            }

            this.$refs.type.resetValidation();
            this.$refs.status.resetValidation();
        },
        validate() {
            const validations = [
                this.$refs.type.validate(true),
                this.$refs.status.validate(true),
            ];

            if (this.$refs.name) {
                validations.push(this.$refs.name.validate(true));
            }

            return validations.every(Boolean);
        },
        async save() {
            if (!this.validate()) return;

            if (!this.votingRegForm.dob) {
                return this.$notify({
                    group: "notification",
                    text: "Missing Source",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post("api/votingRegstrationFormStatus/save", [
                    {
                        id: this.votingRegForm.id,
                        dateSubmitted: this.votingRegForm.dateSubmitted
                            ? this.votingRegForm.dateSubmitted
                            : null,
                        personID: this.person ? this.person.personID : null,
                        studentID: this.student ? this.student.id : null,
                        type: this.votingRegForm.type,
                        name:
                            this.votingRegForm.firstName +
                            " " +
                            this.votingRegForm.lastName,
                        address: this.getAddress(),
                        dob: this.votingRegForm.dob,
                        note: this.votingRegForm.note,
                        status: this.votingRegForm.status,
                        enteredBy: this.$store.state.authentication.user,
                    },
                ]);

                this.close();
                this.reload();

                this.votingRegForm = {
                    id: 0,
                    firstName: "",
                    lastName: "",
                    dateSubmitted: "",
                    type: "",
                    note: "",
                    status: "Pending",
                    dob: "",
                    datePickerMenu: false,
                    datePickerMenu2: false,
                };

                this.$notify({
                    group: "notification",
                    text: this.form ? "Changes Saved" : "Form Saved",
                    type: "success",
                });

                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.scroll-container {
    height: 100%;
    overflow-y: scroll;
    backface-visibility: hidden;
}
</style>
